import { _get } from './api';
import { _copyToClipboard } from './copyToClipboard';
import { _getBankNameFromIban } from './getBankName';
import { _persianDigit } from './persianDigit';
import { _plainNumber, _priceDigit } from './price';

export { _get as get };
export { _priceDigit as priceDigit };
export { _plainNumber as plainNumber };
export { _persianDigit as persianDigit };
export { _getBankNameFromIban as getBankNameFromIban };
export { _copyToClipboard as copyToClipboard };
